module.exports = __webpack_public_path__ + "static/img/image047.e13fd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news7/image047.png
// module id = I59S
// module chunks = 1